export enum Authority {
  MANAGEMENT_OPERATOR = 'management-operator',
  MANAGEMENT_READER = 'management-reader',
  MANAGEMENT_DR_OPERATOR = 'management-dr-operator'
}
